@if (isUpdate) {
  <div class="row">
    <div class="col-lg-12 mb-4 text-justify">{{ 'company.businessInfoDesc' | translate }}</div>
  </div>
}

@if (isPreloading) {
  <agmo-loading></agmo-loading>
}

@if (form && ckEditorLoaded && !isPreloading) {
  <form (ngSubmit)="submit()" [formGroup]="form" [class.show-form-error]="showFormError">
    <div class="row">
      <div class="col-lg-12 input-panel">
        @if (!isLoading) {
          <div class="input-field">
            <div
              class="profile-upload square-upload"
              [class.m-0]="isUpdate"
              agmoUploader
              accept="image/*"
              (selectFiles)="selectFile($event, 1)"
            >
              @if (!logoUrl) {
                <div class="profile-image pitchin-icon-company-logo"></div>
              }
              @if (logoUrl) {
                <img class="profile-image" alt="Company" [src]="logoUrl" />
              }
              @if (logoUrl) {
                <div class="pitchin-icon pitchin-icon-add"></div>
              }
            </div>
          </div>
        }
        @if (!logoUrl) {
          <div class="text-primary pt-3" [class.text-center]="!isUpdate">
            {{ 'company.squareLogoInstruction' | translate }}
          </div>
        }
        @if (isLoading) {
          <agmo-loading></agmo-loading>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 input-panel">
        <div class="input-label">
          {{ (isUpdate ? 'company.registeredName' : 'company.name') | translate }}*
        </div>
        <div class="input-field">
          <input class="form-control" formControlName="name" type="text" />
        </div>
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.businessRegistrationNumber' | translate }}*</div>
        <div class="input-field">
          <input
            class="form-control"
            formControlName="registrationNumber"
            type="text"
            maxlength="20"
            alphanumeric
          />
        </div>
      </div>
      <div class="col-lg-6 input-panel" [hidden]="!isIssuer">
        <div class="input-label">
          {{ 'company.brandName' | translate }}*
          <button
            type="button"
            #tooltip="matTooltip"
            (click)="tooltip.toggle()"
            class="btn-transparent"
            matTooltip="{{ 'company.brandNameTooltips' | translate }}"
            matTooltipClass="tooltip-inner"
          >
            <i class="fa fa-info-circle"></i>
          </button>
        </div>
        <div class="input-field">
          <input class="form-control" formControlName="brandName" type="text" maxlength="50" />
        </div>
        <div class="input-desc">
          ({{ 'company.optimalCharacterLength' | translate: { noOfCharacters: 50 } }})
        </div>
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.incorporatedSince' | translate }}*</div>
        <div class="input-field date-input" (click)="incorporatedDate.open()">
          <input
            class="form-control !tw-bg-white"
            [matDatepicker]="incorporatedDate"
            [min]="minDate"
            [max]="todayDate"
            formControlName="incorporatedDate"
            name="incorporatedDate"
            placeholder="DD/MM/YYYY"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="incorporatedDate" disableRipple>
            <div class="pitchin-icon pitchin-icon-calendar" matDatepickerToggleIcon></div>
          </mat-datepicker-toggle>
          <mat-datepicker #incorporatedDate></mat-datepicker>
        </div>
        @if (form.controls.incorporatedDate.errors && showFormError) {
          <div class="error">
            {{ 'common.incorrectMinYear' | translate: { 'year': 1700 } }}
          </div>
        }
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.whatTypeOfBusiness' | translate }}*</div>
        <mat-radio-group
          formControlName="companyType"
          (change)="changeValidity('companyType', 'otherCompanyType', CorporateBusinessType.Other)"
        >
          @for (type of corporateBusinessType; track type) {
            <mat-radio-button class="d-block" [value]="type">
              <div class="d-flex align-items-center">
                {{ 'company.' + CorporateBusinessType[type] | translate }}
                @if (
                  type == CorporateBusinessType.Other &&
                  form.value.companyType == CorporateBusinessType.Other
                ) {
                  <input
                    class="form-control ml-3"
                    formControlName="otherCompanyType"
                    type="text"
                    placeholder="{{ 'common.pleaseProvide' | translate }}"
                  />
                }
              </div>
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
      @if (isIssuer && !isUpdate) {
        <div class="col-lg-6 input-panel d-none d-lg-block"></div>
      }
      @if (isIssuer && isUpdate) {
        <div class="col-lg-6 input-panel">
          <div class="input-label">{{ 'common.tags' | translate }}</div>
          <app-issuer-campaign-tags [campaign]="company?.latestCampaign" />
        </div>
      }
      <div class="col-lg-6 input-panel" [class.col-lg-12]="!isIssuer">
        <div class="input-label">{{ 'company.tagline' | translate }}</div>
        <div class="input-field">
          @if (isIssuer) {
            <textarea
              class="form-control"
              [placeholder]="'company.taglinePlaceholder' | translate"
              rows="3"
              formControlName="tagline"
              (change)="checkNoOfWords()"
            ></textarea>
          }
          @if (!isIssuer) {
            <input
              (change)="checkNoOfWords()"
              class="form-control"
              formControlName="tagline"
              [placeholder]="'company.taglinePlaceholder' | translate"
              type="text"
            />
          }
        </div>
        <div class="input-desc">({{ 'company.wordsLimit' | translate: { noOfWords: 15 } }})</div>
      </div>
      @if (isIssuer) {
        <div class="col-lg-6 input-panel">
          <div class="input-label">
            {{ (isIssuer ? 'company.businessSummary' : 'company.summary') | translate }}*
          </div>
          <div class="input-field">
            <textarea
              class="form-control"
              rows="3"
              formControlName="description"
              maxlength="90"
              [placeholder]="'company.summaryPlaceholder' | translate"
            ></textarea>
          </div>
          <div class="input-desc">
            ({{ 'company.optimalCharacterLength' | translate: { noOfCharacters: 90 } }})
          </div>
        </div>
      }
      @if (isIssuer) {
        <div class="col-lg-12 input-panel">
          <div class="input-label">{{ 'company.about' | translate }}</div>
          <div class="input-field">
            <ckeditor
              class="ck-editor"
              formControlName="info"
              (focus)="removeRichText($event)"
              [editor]="Editor"
              [config]="ckEditorConfig"
            ></ckeditor>
          </div>
        </div>
      }
      @if (isIssuer) {
        <ng-container *ngTemplateOutlet="addressForm"></ng-container>
      }
      @if (!isIssuer) {
        <div class="col-lg-12 input-panel">
          <fieldset class="inputGroup">
            <legend>
              {{
                (isUpdate ? 'company.registeredAddressUpdate' : 'company.registeredAddress')
                  | translate
              }}
            </legend>
            <div class="row">
              <ng-container *ngTemplateOutlet="addressForm"></ng-container>
            </div>
          </fieldset>
        </div>
      }
      @if (!isIssuer) {
        <div class="col-lg-12 input-panel">
          <fieldset class="inputGroup">
            <legend>
              {{
                (isUpdate ? 'company.businessAddress' : 'company.businessLLPAddress') | translate
              }}
            </legend>
            <div class="row">
              @if (!isIssuer) {
                <div class="col-lg-12 input-panel">
                  <mat-checkbox formControlName="sameAsRegisteredAddress" (change)="copyAddress()">
                    {{ 'company.sameAsRegisteredAddress' | translate }}
                  </mat-checkbox>
                </div>
              }
              <div class="col-lg-12 input-panel">
                <div class="input-label">{{ 'company.address' | translate }}*</div>
                <div class="input-field">
                  <textarea
                    class="form-control"
                    rows="3"
                    formControlName="businessAddress"
                  ></textarea>
                </div>
              </div>
              <div class="col-lg-6 input-panel">
                <div class="input-label">{{ 'company.postcode' | translate }}*</div>
                <div class="input-field">
                  <input
                    class="form-control"
                    formControlName="businessPostCode"
                    type="text"
                    alphanumeric
                    maxlength="20"
                  />
                </div>
              </div>
              <div class="col-lg-6 input-panel">
                <div class="input-label">{{ 'company.city' | translate }}*</div>
                <div class="input-field">
                  <input class="form-control" formControlName="businessCity" type="text" />
                </div>
              </div>
              <div class="col-lg-6 input-panel">
                <div class="input-label">{{ 'raise.country' | translate }}*</div>
                <div class="input-field">
                  <mat-select
                    [placeholder]="'common.selectPlaceholder' | translate"
                    class="form-control"
                    formControlName="businessCountryId"
                    (selectionChange)="getStates(form.value.businessCountryId, 'businessStateId')"
                  >
                    @for (country of countries; track country) {
                      <mat-option [value]="country.isoCode">
                        {{ country.name }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              </div>
              <div class="col-lg-6 input-panel">
                <div class="input-label">
                  {{ 'company.state' | translate }}
                  @if (businessStates && businessStates.length > 0) {
                    <span>*</span>
                  }
                </div>
                <div class="input-field">
                  <mat-select
                    [placeholder]="'common.selectPlaceholder' | translate"
                    class="form-control"
                    formControlName="businessStateId"
                  >
                    @for (state of businessStates; track state) {
                      <mat-option [value]="state.isoCode">
                        {{ state.name }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      }
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.phoneNo' | translate }}*</div>
        <div class="input-field phone-input-field">
          <mat-select class="form-control countryCode" formControlName="phoneCountryCode">
            <mat-select-trigger>
              {{ form.value.phoneCountryCode }}
            </mat-select-trigger>
            @for (country of countries; track country) {
              <mat-option [value]="country.phonecode">
                {{ country.name }} ({{ country.phonecode }})
              </mat-option>
            }
          </mat-select>
          <input class="form-control" formControlName="phoneNumber" type="text" digitOnly />
        </div>
        @if (
          form.controls.phoneNumber.errors &&
          form.controls.phoneNumber.errors.phoneInvalidFormat &&
          showFormError
        ) {
          <div class="error">
            {{ 'common.incorrectPhoneNoFormat' | translate }}
          </div>
        }
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.companyEmail' | translate }}*</div>
        <div class="input-field">
          <input class="form-control" formControlName="email" type="text" maxlength="50" />
        </div>
        @if (showFormError && form.controls.email.errors && form.controls.email.errors.pattern) {
          <div class="error">
            {{ 'signUp.emailFormatIncorrect' | translate }}
          </div>
        }
      </div>
      <div class="col-lg-12 input-panel">
        <div class="input-label">{{ 'company.sectors' | translate }}*</div>
        <div class="input-field">
          <app-select-search-filter
            class="w-100"
            [max]="2"
            [(list)]="sectors"
            [(selectedList)]="selectedSectors"
            [placeholder]="'company.searchSectors'"
            (goSearch)="getSectors($event)"
          >
          </app-select-search-filter>
        </div>
        @if (showFormError && selectedSectors.length == 0) {
          <div class="error">
            {{ 'company.sectorIsRequired' | translate }}
          </div>
        }
      </div>
      <div class="col-lg-12 input-panel" [class.form-group]="!msicCodes || msicCodes.length == 0">
        <div class="row">
          <div class="col-lg-6">
            <div class="input-label">{{ 'company.msicCode' | translate }}</div>
            <div class="input-field d-flex">
              <input
                type="text"
                class="form-control w-75 mr-3"
                [(ngModel)]="msicCode"
                alphanumeric
                [ngModelOptions]="{ standalone: true }"
              />
              <button
                type="button"
                class="btn btn-primary btn-block btn-add w-25"
                (click)="addCode()"
              >
                {{ 'common.add' | translate }}
              </button>
            </div>
          </div>
          @if (msicCodes && msicCodes.length > 0) {
            <div class="col-lg-12">
              @for (code of msicCodes; track code) {
                <div class="block-badge-wrap">
                  <div class="d-flex flex-row block-badge mr-3">
                    <div class="font-weight-bold mr-2" [matTooltip]="code">
                      {{ code.length > 20 ? code.slice(0, 20) + '...' : code }}
                    </div>
                    <div class="mr-2">|</div>
                    <div class="align-self-center cursor-pointer" (click)="deleteCode(code)">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.website' | translate }}</div>
        <div class="input-field">
          <input class="form-control" formControlName="websiteUrl" type="text" />
        </div>
        @if (showFormError && form.controls.websiteUrl.errors?.pattern) {
          <div class="text-danger">
            {{ 'common.invalidUrl' | translate }}
          </div>
        }
      </div>
      @if (isIssuer) {
        <div class="col-lg-6 input-panel">
          <div class="input-label">{{ 'company.reel' | translate }}</div>
          <div class="input-field">
            <input class="form-control" formControlName="videoUrl" type="text" />
          </div>
          <div class="input-desc">{{ 'company.pasteVideoUrl' | translate }}</div>
        </div>
      }
      <ng-container formArrayName="companySocialLinks">
        @for (socialLink of socialFormControl.controls; track socialLink; let i = $index) {
          <div class="col-lg-6 input-panel" formGroupName="{{ i }}">
            <div class="input-label">
              {{ 'common.' + SocialLinkType[socialLink.value.type] | translate }}
            </div>
            <div class="input-field">
              <input class="form-control" formControlName="url" type="text" />
            </div>
          </div>
        }
      </ng-container>
      @if (isIssuer) {
        <div class="col-lg-7 input-panel">
          <div class="input-label">{{ 'company.banner' | translate }}</div>
          @if (!isBannerLoading) {
            <div class="input-field">
              @if (!bannerUrl) {
                <div
                  class="banner-upload"
                  agmoUploader
                  [accept]="accept"
                  (selectFiles)="selectFile($event, 2)"
                >
                  <div class="upload-container upload-field d-flex">
                    <div class="align-self-center px-4">
                      <div class="pitchin-icon pitchin-icon-upload"></div>
                      <div class="drop-document">
                        {{ 'company.uploadImage' | translate }}
                      </div>
                      <div class="upload-document-instruction">
                        {{ 'company.uploadDocumentInstruction' | translate }}
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (bannerUrl) {
                <div class="banner-upload">
                  <div class="upload-container">
                    @if (bannerUrl) {
                      <img class="banner-image" alt="Company Banner" [src]="bannerUrl" />
                    }
                    @if (bannerUrl) {
                      <div class="pitchin-icon pitchin-icon-add" (click)="removeBanner()"></div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (isBannerLoading) {
            <agmo-loading></agmo-loading>
          }
        </div>
      }
      @if (!isIssuer) {
        <hr class="w-100" />
        <div class="col-lg-6 input-panel">
          <div class="input-label">{{ 'company.grossAnnualRevenue' | translate }}*</div>
          <div class="input-field">
            <mat-select
              [placeholder]="'common.selectPlaceholder' | translate"
              class="form-control"
              formControlName="grossAnnualRevenueType"
            >
              @for (type of grossAnnualRevenue; track type) {
                <mat-option [value]="type.id">
                  {{ type.name }}
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
        <div class="col-lg-12 input-panel">
          <div class="input-label">{{ 'company.corporateCategory' | translate }}*</div>
          <div class="input-field">
            <mat-select
              [placeholder]="'common.selectPlaceholder' | translate"
              class="form-control"
              formControlName="corporateCategoryType"
              (selectionChange)="
                changeValidity(
                  'corporateCategoryType',
                  'othersCorporateCategoryType',
                  this.othersId
                )
              "
            >
              @for (type of corporateCategory; track type) {
                <mat-option [value]="type.id">
                  {{ type.name }}
                </mat-option>
              }
            </mat-select>
            @if (form.value.corporateCategoryType == othersId) {
              <input
                class="form-control mt-2"
                formControlName="othersCorporateCategoryType"
                type="text"
                placeholder="{{ 'common.pleaseSpecify' | translate }}"
                maxlength="512"
              />
            }
          </div>
        </div>
      }
      <div class="col-12 input-panel">
        <div class="mt-4 d-flex">
          <mat-checkbox formControlName="isCheck" name="isCheck" required> </mat-checkbox>
          <div [innerHTML]="'profile.confirmInfo' | translate"></div>
        </div>
      </div>
    </div>
    <div class="row pt-5">
      <div class="col-lg-6 col-md-8 input-panel" [class.m-auto]="!isUpdate">
        <button type="submit" class="btn btn-primary btn-submit">
          {{ (isUpdate ? 'common.update' : 'common.next') | translate }}
        </button>
      </div>
    </div>
    <ng-template #addressForm>
      <div class="col-lg-12 input-panel">
        <div class="input-label">
          {{ (isIssuer ? 'company.businessAddress' : 'company.address') | translate }}*
        </div>
        <div class="input-field">
          @if (isIssuer) {
            <textarea class="form-control" rows="3" formControlName="address"></textarea>
          }
          @if (!isIssuer) {
            <input class="form-control" formControlName="address" type="text" />
          }
        </div>
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.postcode' | translate }}*</div>
        <div class="input-field">
          <input
            class="form-control"
            formControlName="postCode"
            type="text"
            alphanumeric
            maxlength="20"
          />
        </div>
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'company.city' | translate }}*</div>
        <div class="input-field">
          <input class="form-control" formControlName="city" type="text" />
        </div>
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">{{ 'raise.country' | translate }}*</div>
        <div class="input-field">
          <mat-select
            [placeholder]="'common.selectPlaceholder' | translate"
            class="form-control"
            formControlName="countryId"
            (selectionChange)="getStates(form.value.countryId, 'stateId')"
            [disabled]="isIssuer"
          >
            @for (country of countries; track country) {
              <mat-option [value]="country.isoCode">
                {{ country.name }}
              </mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="col-lg-6 input-panel">
        <div class="input-label">
          {{ 'company.state' | translate }}
          @if (states && states.length > 0) {
            <span>*</span>
          }
        </div>
        <div class="input-field">
          <mat-select
            [placeholder]="'common.selectPlaceholder' | translate"
            class="form-control"
            formControlName="stateId"
          >
            @for (state of states; track state) {
              <mat-option [value]="state.isoCode">
                {{ state.name }}
              </mat-option>
            }
          </mat-select>
        </div>
      </div>
    </ng-template>
  </form>
}
